import React from "react";
import PropTypes from "prop-types";
import {
  _MeasureSketchContainer as MeasureSketchContainer,
  TopText,
  _SketchComposer as SketchComposer,
  LeftText,
  CenterText,
  Sketch,
  OverlayImage,
  RightText,
  BottomText,
  HeadLine,
  HeadlineContainer,
} from "./style";

export const MeasureSketch = ({
  imageUrl,
  overlayImageUrl,
  topText,
  leftText,
  centerText,
  rightText,
  bottomText,
  headLine,
  frameType,
}) => {
  return (
    <MeasureSketchContainer data-id={`MeasureSketch_${centerText}`}>
      {headLine && (
        <HeadlineContainer>
          <HeadLine>{headLine}</HeadLine>
        </HeadlineContainer>
      )}
      <TopText>{topText}</TopText>
      <SketchComposer>
        <LeftText>{leftText}</LeftText>
        <CenterText>{centerText}</CenterText>
        <Sketch
          className={
            frameType === "LYCKA" ||
            frameType === "SKAPA" ||
            frameType === "ONSKA"
              ? "invert"
              : ""
          }
          src={imageUrl}
        />
        {overlayImageUrl && (
          <OverlayImage className="overlay-image" src={overlayImageUrl} />
        )}
        <RightText>{rightText}</RightText>
        <BottomText>{bottomText}</BottomText>
      </SketchComposer>
    </MeasureSketchContainer>
  );
};

MeasureSketch.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  overlayImageUrl: PropTypes.string,
  topText: PropTypes.node,
  leftText: PropTypes.node,
  centerText: PropTypes.string,
  rightText: PropTypes.node,
  bottomText: PropTypes.node,
  headLine: PropTypes.string,
  frameType: PropTypes.string,
};
